import { sendSlackNotification } from "../../Services/slack/sendSlackNotification";

const handleErrorLandings = async ({
  error,
  landingId,
  navigate,
  navigatePath,
  message,
}) => {
  try {
    console.log(
      `Ocurrio un error inesperado en al landing: ${landingId}`,
      error
    );
    await sendSlackNotification({
      message,
      chanelID: "C020Q7623HC",
    });
    if (navigatePath) {
      navigate(navigatePath);
    }
  } catch (err) {
    console.log(`No pudimos enviar el mensaje a slack: ${landingId}`);
  }
};

export default handleErrorLandings;
